type VideoSdkValidationParams = {
  roomId?: string | null;
  token?: string | null;
};

export function canValidateVideoSdkRoom({ roomId, token }: VideoSdkValidationParams): boolean {
  return Boolean(roomId && token);
}
